export default __webpack_public_path__ + "static/media/66.15f772c6.svg";